import { ECHARTS_DECAL_PATTERNS, EchartsDecalPattern } from '@/utils/echarts-utils'
import { AlertCircle, AlertTriangle, IconNode } from 'lucide'

export enum ConditionStatus {
    None = 0,
    Normal,
    Inferior,
    Critical,
    NoAction,
}

export const StatusTypes = [
    {
        labelKey: 'common.statusTypes.none',
        value: ConditionStatus.None,
        color: '#ADADAD',
    },
    {
        labelKey: 'common.statusTypes.normal',
        value: ConditionStatus.Normal,
        color: '#27AE60',
    },
    {
        labelKey: 'common.statusTypes.inferior',
        value: ConditionStatus.Inferior,
        color: '#F2994A',
    },
    {
        labelKey: 'common.statusTypes.critical',
        value: ConditionStatus.Critical,
        color: '#BB3333',
    },
    {
        labelKey: 'common.statusTypes.noAction',
        value: ConditionStatus.NoAction,
        color: '#414651',
    },
] as const

export const statusIcons: Record<number, { iconNode: IconNode; color: string }> = {
    [ConditionStatus.Inferior]: {
        iconNode: AlertTriangle,
        color: StatusTypes.find((e) => e.value === ConditionStatus.Inferior)?.color ?? '',
    },
    [ConditionStatus.Critical]: {
        iconNode: AlertCircle,
        color: StatusTypes.find((e) => e.value === ConditionStatus.Critical)?.color ?? '',
    },
}

export const SUMMARY_STATUS = {
    [ConditionStatus.None]: {
        id: ConditionStatus.None,
        name: StatusTypes[ConditionStatus.None].labelKey,
        color: StatusTypes[ConditionStatus.None].color,
        pattern: ECHARTS_DECAL_PATTERNS[EchartsDecalPattern.None],
    },
    [ConditionStatus.Normal]: {
        id: ConditionStatus.Normal,
        name: StatusTypes[ConditionStatus.Normal].labelKey,
        color: StatusTypes[ConditionStatus.Normal].color,
        pattern: ECHARTS_DECAL_PATTERNS[EchartsDecalPattern.None],
    },
    [ConditionStatus.Inferior]: {
        id: ConditionStatus.Inferior,
        name: StatusTypes[ConditionStatus.Inferior].labelKey,
        color: StatusTypes[ConditionStatus.Inferior].color,
        pattern: ECHARTS_DECAL_PATTERNS[EchartsDecalPattern.Lines45],
    },
    [ConditionStatus.Critical]: {
        id: ConditionStatus.Critical,
        name: StatusTypes[ConditionStatus.Critical].labelKey,
        color: StatusTypes[ConditionStatus.Critical].color,
        pattern: ECHARTS_DECAL_PATTERNS[EchartsDecalPattern.Rectangles],
    },
    [ConditionStatus.NoAction]: {
        id: ConditionStatus.NoAction,
        name: StatusTypes[ConditionStatus.NoAction].labelKey,
        color: StatusTypes[ConditionStatus.NoAction].color,
        pattern: ECHARTS_DECAL_PATTERNS[EchartsDecalPattern.Circles],
    },
}